<template>
  <div>
    <v-row class="mb-4 mt-3">
      <successModal
        ref="success_modal"
        v-on:confirm="closeSuccessModal"
      ></successModal>
      <v-col class="col-md-7 col-lg-8 col-sm-5" cols="12">
        <h3 class="font ml-3">
          <span class="underline-text" v-if="getClient"
            >{{ getClient.name }}:</span
          >
          Add New Partner - Search Results
        </h3>
      </v-col>
    </v-row>

    <v-row v-if="loader" class="justify-center col-md-12">
      <v-progress-circular
        :size="200"
        class="text-center"
        indeterminate
        color="primary"
      ></v-progress-circular>
    </v-row>
    <v-simple-table v-else fixed-header height="630px">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">Organization Name</th>
            <th class="text-left">Individual Name</th>
            <th class="text-left">Type</th>
            <th class="text-left">City</th>
            <th class="text-left">State</th>
            <th class="no-padding text-end justify-end" v-if="$role != 'user'">
              <div class="col-md-12 justify-end d-flex text-end">
                <v-checkbox
                  v-model="allRows"
                  class="no-padding mt-3"
                  @click="selectAllRows1()"
                ></v-checkbox>
                <label for="" style="padding-top: 11px">Select all </label>
              </div>
            </th>
          </tr>
        </thead>
        <tbody v-if="items.length > 0">
          <tr
            v-for="(item, index) in items"
            :key="item.name"
            :class="selectAll ? 'activeItem' : ''"
            :id="'id' + index"
          >
            <td>
              <a @click="singleItem(item)">{{ item.companyName }} </a>
            </td>
            <td v-if="item.primaryContact">
              {{ item.primaryContact.firstName }}
              {{ item.primaryContact.lastName }}
            </td>
            <td v-else>/</td>
            <td
              v-html="
                item.advisorType == 'brokerConsultant'
                  ? 'Broker Consultant'
                  : item.advisorType == 'analyticsConsultant'
                  ? 'Analytics Consultant'
                  : item.advisorType
              "
            >
              {{ item.advisorType }}
            </td>
            <td v-html="item.city ? item.city : '/'"></td>
            <td v-html="item.state ? item.state : '/'"></td>
            <td
              v-if="$role != 'user'"
              class="text-center mt-3 row no-padding justify-end"
              style="padding-right: 90px"
            >
              <v-checkbox
                class="stay-blue no-padding"
                v-model="item.checkbox"
                @click="activeRow1(index, item)"
              ></v-checkbox>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <v-col class="com-md-12 ml-2">
            <a
              v-if="$role != 'user'"
              @click="$router.push('/employer/partners/invite-partner')"
              >No Results Found - Click Here to Invite a Partner</a
            >
            <span v-else>No Results Found</span>
          </v-col>
        </tbody>
      </template>
    </v-simple-table>
    <div class="row col-md-12 justify-end mt-2" v-if="$role != 'user'">
      <v-btn
        class="blue-buttons"
        :class="getResult.length > 0 ? 'mr-10' : ''"
        @click="$router.replace('/employer/partners')"
      >
        Cancel
      </v-btn>
      <v-btn
        class="blue-buttons"
        v-if="getResult.length > 0"
        @click="addPartner()"
      >
        Add Selected
      </v-btn>
    </div>
    <errorModal ref="error_modal" v-on:confirm="closeErrorModal"></errorModal>
  </div>
</template>
<script>
import successModal from "../../../TablesTemplate/SuccessDialog.vue";
import errorModal from "../../../TablesTemplate/ErrorDialog.vue";
import api from "../../../../services/api";
import { mapGetters } from "vuex";

export default {
  components: { successModal, errorModal },
  data() {
    return {
      selected: [],
      selectAll: false,
      selectedRows: [],
      items: [],
      checkIfSelect: false,
      allRows: false,
      allPartners: [],
      checkIfClicked: false,
      loader: false,
    };
  },
  computed: {
    getClient() {
      return this.$store.getters.getClientGetter;
    },
    getResult() {
      return this.$store.getters.getPartnersSearchResultInEmployerAdvisor;
    },
    ...mapGetters(["getAllPartners"]),
  },
  created() {
    this.allPartners = this.getResult;
    this.items = this.getResult;
  },
  methods: {
    selectAllRows1() {
      this.selectedRows = [];

      if (!this.checkIfSelect) {
        this.selectedRows = [];
        this.checkIfClicked = false;
        this.items.forEach((el) => {
          el.checkbox = false;
        });
      }
      if (this.checkIfSelect) {
        this.items = [];
        this.loader = true;
        this.items = this.allPartners;
        let tmp = JSON.stringify(this.items);
        this.selectedRows = JSON.parse(tmp);
        this.checkIfSelect = false;

        setTimeout(() => {
          this.items.forEach((el) => {
            el.checkbox = true;
          });
          this.loader = false;
        }, 0);

        //  this.$forceUpdate();
      } else if (this.selectAll && !this.checkIfSelect) {
        this.selectAll = false;
      } else {
        this.selectAll = !this.selectAll;
        if (!this.selectAll) {
          this.selectedRows = [];
          this.checkIfClicked = false;
          this.items.forEach((el) => {
            el.checkbox = false;
          });
        } else {
          this.items.forEach((el) => {
            el.checkbox = true;
          });
          this.selectedRows = [];
          let tmp = JSON.stringify(this.items);
          this.selectedRows = JSON.parse(tmp);
        }
      }
    },
    activeRow1(index, item) {
      let itemById = document.getElementById("id" + index);
      if (this.allRows) {
        this.checkIfSelect = true;
        let removeItem = this.selectedRows.find((x) => x._id === item._id);
        this.selectedRows.splice(this.selectedRows.indexOf(removeItem), 1);
        itemById.classList.remove("activeItem");
        this.allRows = false;
        this.checkIfClicked = true;
      } else {
        itemById.classList.toggle("activeItem");
        if (this.checkIfClicked) {
          itemById.classList.remove("activeItem");
        }
        if (item.checkbox) {
          this.selectedRows.push(item);
        } else {
          let removeItem = this.selectedRows.find((x) => x._id === item._id);
          this.selectedRows.splice(this.selectedRows.indexOf(removeItem), 1);
        }
      }
  
    },
    singleItem(item) {
      this.$store.commit("setSinglePartnerInEmployerAdvisor", item);
      this.$store.commit("singlePartnerDeleteButton", false);
      this.$router.push(`/employer/partners/partner`);
    },
    closeSuccessModal() {
      this.$refs.success_modal.closePopUp();
      this.$router.push("/employer/partners");
    },
    closeErrorModal() {
      this.$refs.error_modal.closePopUp();
    },
    addPartner() {
      if (this.selectedRows.length < 1) {
        let text = "You must  select at least one Partner";
        this.$refs.error_modal.openPopUp(text);
        return;
      }
      if (this.selectedRows.length < 1) {
        let text = "You must  select at least one Partner";
        this.$refs.error_modal.openPopUp(text);
        return;
      }
     
      let exist = false;
      this.getAllPartners.forEach((el) => {
        if (this.selectedRows.some((t) => t._id == el._id)) {
          this.$refs.error_modal.openPopUp("Partner Already Exists");
          exist = true;
          return;
        }
      });
      if (!exist) {
        let data = {
          ids: this.selectedRows,
        };
        let user = JSON.parse(localStorage.getItem("user"));
        let advisorId = user.groupPortal[0].organization.employer;

        api()
          .post(`/employers/${advisorId}/advisors`, data)
          .catch((err) => {
            if (err) {
              if (err.response.data.error) {
                this.$refs.error_modal.openPopUp(err.response.data.error);
              } else if (err.response.data.message) {
                this.$refs.error_modal.openPopUp(err.response.data.message);
              }
            }
          })
          .then((res) => {
            if (res) {
              let text = "Partners added successfully";
              this.$refs.success_modal.openPopUp(text);
            }
          });
      }
    },
    selectAllRows() {
      this.selectedRows = [];
      this.selectAll = !this.selectAll;
      this.getResult.forEach((el) => {
        this.selectedRows.push(el._id);
      });
      if (!this.selectAll) {
        this.selectedRows = [];
      }
    },
    activeRow(index, item) {
      let itemById = document.getElementById("id" + index);
      itemById.classList.toggle("activeItem");
      if (itemById.classList.contains("activeItem")) {
        this.selectedRows.push(item._id);
      } else {
        let removeItem = this.selectedRows.find((x) => x === item._id);
        this.selectedRows.splice(this.selectedRows.indexOf(removeItem), 1);
      }
    },
  },
};
</script>
